// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"765":"a27628de","787":"45879896"}[chunkId] + ".chunk.js";
};